function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M163.3,152.2V50.8h-12v101.4c-17.1,3.3-28.2,19.8-24.9,36.9,3.3,17.1,19.8,28.2,36.9,24.9,17.1-3.3,28.2-19.8,24.9-36.9-2.4-12.6-12.3-22.5-24.9-24.9h0ZM188.8,136V31.9C189.1,14.6,175.3.3,158,0c-17.3-.3-31.6,13.5-31.9,30.8v1.1h-.1v104.2c-26,17.3-33.1,52.5-15.7,78.5,17.3,26,52.5,33,78.5,15.7,26-17.3,33.1-52.5,15.7-78.5h0c-4.2-6.2-9.5-11.6-15.7-15.8ZM157.4,227.7c-24.6,0-44.6-19.9-44.6-44.5,0-17.1,9.8-32.8,25.2-40.2V31.9h.1c0-10.7,8.6-19.4,19.3-19.4,10.4,0,18.9,8.1,19.4,18.5v112c22.2,10.7,31.5,37.3,20.8,59.5-7.4,15.4-23.1,25.2-40.2,25.2h0ZM201.3,76.3h50.3v12.6h-50.3v-12.6ZM201.3,51.1h50.3v12.6h-50.3v-12.6ZM201.3,101.5h50.3v12.6h-50.3v-12.6Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M83.4,62.1v115.9H11V62.1h72.4M94.3,51.1H0v137.8h94.3V51.1h0Z"
});

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  points: "52.9 86.3 32 124.9 47.2 124.9 41.4 157.5 62.3 118.8 47.2 118.8 52.9 86.3"
});

function SvgEHeating(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 251.6 239.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEHeating);
export default __webpack_public_path__ + "static/media/e-heating.9a40d6c49c1e08b6a8a8187992af1d94.svg";
export { ForwardRef as ReactComponent };